import { NgModule } from '@angular/core';
import { ThreadsBackgroundComponent } from './threads-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        ThreadsBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ThreadsBackgroundComponent
    ]
})
export class NcThreadsBackgroundModule { }